import React, { useState, useRef, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

const MapPicker = ({ onSelect, initialPosition = [14.726840, -17.440989], isModalVisible }) => {
  const [position, setPosition] = useState(initialPosition);
  const mapRef = useRef();

  useEffect(() => {
    if (isModalVisible && mapRef.current) {
      setTimeout(() => {
        mapRef.current.invalidateSize(); // Forcer le redimensionnement de la carte
      }, 200); // Petit délai pour s'assurer que le modal est complètement visible
    }
  }, [isModalVisible]);

  const LocationMarker = () => {
    useMapEvents({
      click(e) {
        const newPosition = [e.latlng.lat, e.latlng.lng];
        setPosition(newPosition);
        onSelect(newPosition);
      },
    });

    return position ? <Marker position={position} /> : null;
  };

  return (
    <MapContainer
      key={isModalVisible ? 'mapVisible' : 'mapHidden'} // Forcer la recréation de la carte
      center={position}
      zoom={13}
      style={{ height: '400px', width: '100%' }}
      ref={mapRef}
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution="&copy; OpenStreetMap contributors"
      />
      <LocationMarker />
    </MapContainer>
  );
};

export default MapPicker;
